import React from 'react';

import Image from 'react-bootstrap/Image';

class Header extends React.Component {
    render() {
	return (
	    <Image fluid src="banner.jpg" />
	);
    }
}

export default Header;
